'use strict';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

/**
 * Basic button
 *
 * @param {String}   type: type of button [big]
 * @param {Function} onClick: onClick callback
 * @param {Array}    children: children of this button, usually text
 * @param {String}   className: additional classnames for button
 * @param {Boolean}  disabled: show button as disabled
 * @param {string|Function}   message: message id. If supplied, creates a message with the id.
 * */
const OTButton = ({
  type,
  onClick,
  children,
  className,
  disabled = false,
  message,
  color,
  style,
}) => {
  let _color = `ot-button--${color}`;
  let _message = null;
  if (message) {
    _message =
      typeof message === 'function' ? (
        <FormattedMessage id={message()} />
      ) : (
        <FormattedMessage id={message} />
      );
  }
  return (
    <button
      style={style}
      className={classnames(
        'ot-button',
        { 'ot-button--big': type === 'big', [_color]: _color != null },
        className
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
      {_message}
    </button>
  );
};

export default OTButton;
